var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-lg-12"},[_c('input',{class:['file-input', _vm.classCustom],attrs:{"data-show-preview":"false","type":"file","accept":_vm.acceptFiles ? _vm.acceptFiles : '*',"data-fouc":""},on:{"change":function($event){return _vm.uploadImage($event)}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1e1e67e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/tenancy/admin/restock/UploaderBootstrap.vue
// module id = null
// module chunks = 